window.addEventListener('DOMContentLoaded', () => {
  pagemove();
  cookie();

  // `解答する`ボタン押下によるアクション
  document.getElementById('button_answer').onclick = () => {
    const radioElements = document.getElementsByName('radio');
    const unselectedElement = document.getElementById('misentaku');

    let selectedValue = 0;
    for (let i = 0; i < radioElements.length; i += 1) {
      if (radioElements[i].checked) {
        selectedValue = radioElements[i].value;
        break;
      }
    }

    // 未選択時はここで終了
    if (selectedValue === 0) {
      unselectedElement.innerHTML = '選択されていません';
      return;
    }

    unselectedElement.innerHTML = '';

    const answerHiddenInputValue = document.getElementById('ida').value;
    const correctElement = document.getElementById('correct');
    const incorrectElement = document.getElementById('incorrect');
    const answerButtonElement = document.getElementById('button_kotae');
    let cookieValue;

    if (selectedValue === answerHiddenInputValue) {
      correctElement.innerHTML = '正解';
      incorrectElement.innerHTML = '';
      answerButtonElement.style.display = 'none';
      const answerElement = document.getElementById('answer');
      answerElement.innerHTML = '';
      cookieValue = 0;
    } else if (selectedValue !== 0) {
      correctElement.innerHTML = '';
      incorrectElement.innerHTML = '不正解';
      answerButtonElement.style.display = 'inline-block';
      cookieValue = 1;
    }
    saveCookie(cookieValue);

    // 解説を表示
    const jsExplanation = document.querySelector('.js-exam-explanation');
    if (jsExplanation) {
      jsExplanation.classList.remove('-display-none');
    }
  };

  function saveCookie(value) {
    const name = idu.value; // クッキーの名前
    const period = 1; // 有効期限日数（有効期限がないと、ブラウザを閉じた時点で cookieは無効）
    const nowtime = new Date().getTime();
    const clearTime = new Date(nowtime + (60 * 60 * 24 * 1000 * period));
    const expires = clearTime.toGMTString();// クッキーの発行（書き込み）
    const cookies = document.cookie;
    const cookiesArray = cookies.split('; ');
    let flag = true;
    for (const c of cookiesArray) {
      const cArray = c.split('=');// 名前とvalueの分解
      if (cArray[0] === idu.value) {
        flag = false;
        break;
      }
    }
    if (flag) {
      document.cookie = `${name}=${escape(value)}; expires=${expires}`;
      cookie();
    }
  }

  function cookie() {
    const cookies = document.cookie;
    const cookiesArray = cookies.split('; ');
    const pattern = idu.value.split('_q');
    let total = 0.0;
    let corTotal = 0.0;
    const corArray = [];

    for (const c of cookiesArray) {
      const cArray = c.split('=');// 名前とvalueの分解
      const ccArray = cArray[0].split('_q');// year_season,number.に分解

      if (ccArray[0] === pattern[0]) {
        total += 1;
        if (cArray[1] === '0') {
          corTotal += 1;
          corArray[ccArray[1]] = 0;
        } else {
          corArray[ccArray[1]] = 1;
        }
      }
    }
    if (total === 0) {
      const target = document.getElementById('percent');
      target.innerHTML = 0;
    } else if (total > 0) {
      let percent = (corTotal * 100) / total;
      percent = percent.toFixed();
      const target = document.getElementById('percent');
      target.innerHTML = percent;
    }
    let target = document.getElementById('total');
    target.innerHTML = total;
    target = document.getElementById('cor_total');
    target.innerHTML = corTotal;
    let resetflag = 0;
    let firstflag = 0;

    for (let i = 1; i <= 50; i += 1) {
      target = document.getElementById(`judg${String(i)}`);
      if (corArray[i] === 0) {
        target.innerHTML = '〇';
      } else if (corArray[i] === 1) {
        target.innerHTML = '×';
      } else {
        target.innerHTML = '―';
        resetflag += 1;
        if (i === 1) {
          firstflag += 1;
        }
      }
    }
    if (resetflag === 0) {
      const buttonReset = document.getElementById('button_reset');
      buttonReset.style.display = 'inline-block';
    }
    if (firstflag === 1 && pattern[1] !== 1) {
      const buttonToFirst = document.getElementById('button_tofirst');
      buttonToFirst.style.display = 'inline-block';
    }
  }

  // `答えをみる`ボタン押下によるアクション
  document.getElementById('button_kotae').onclick = () => {
    // 答えを表示
    const answerHiddenInputValue = document.getElementById('ido').value;
    const answerElm = document.getElementById('answer');
    answerElm.innerHTML = answerHiddenInputValue;
  };

  document.getElementById('button_reset').onclick = () => {
    const cookies = document.cookie;
    const cookiesArray = cookies.split('; ');
    const pattern = idu.value.split('_q');
    for (const c of cookiesArray) {
      const cArray = c.split('=');// 名前とvalueの分解
      const ccArray = cArray[0].split('_q');// year_season,numberに分解

      if (ccArray[0] === pattern[0]) {
        document.cookie = `${cArray[0]}=;max-age=0`;
      }
    }
    for (let i = 1; i <= 50; i += 1) {
      const target = document.getElementById(`judg${String(i)}`);
      target.innerHTML = '―';
    }
    let target = document.getElementById('percent');
    target.innerHTML = '0';
    target = document.getElementById('total');
    target.innerHTML = '0';
    target = document.getElementById('cor_total');
    target.innerHTML = '0';
  };

  function pagemove() {
    const u = idu.value.split(/_q/);
    const num = u[1];
    if (num > 1) {
      document.getElementById('button_prev').style.visibility = 'visible';
    } else {
      document.getElementById('button_prev').style.visibility = 'hidden';
    }
    if (num < 50) {
      document.getElementById('button_next').style.visibility = 'visible';
    } else {
      document.getElementById('button_next').style.visibility = 'hidden';
    }
  }
});
